import { render, staticRenderFns } from "./NewTerminal.vue?vue&type=template&id=5b615dba&"
import script from "./NewTerminal.vue?vue&type=script&lang=js&"
export * from "./NewTerminal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports